import { useNavigate, useSearch } from '@tanstack/react-router';

import { OverviewCustomerCompanySelect } from '../../common/form-elements/CompanySelect/OverviewCustomerCompanySelect';
import { PortMultiSelect } from '../../common/form-elements/PortSelect/PortMultiSelect';
import { translate } from '../../common/helpers/translate.helper';
import { useRole } from '../../common/hooks/useRole';
import { DebouncedSearchTextInput } from '../../common/Search/DebouncedSearchTextInput/DebouncedSearchTextInput';
import { Box } from '../../common/ui/Box';

export const AgentsOverviewTableControls = () => {
    const role = useRole();

    const search = useSearch({ from: '/_app/agents/' });
    const navigate = useNavigate({ from: '/agents/' });

    return (
        <Box display="flex" gap={8}>
            <Box minWidth="250px">
                <DebouncedSearchTextInput
                    onChange={(searchQuery) =>
                        navigate({ search: (previousSearch) => ({ ...previousSearch, searchQuery, page: 0 }) })
                    }
                    value={search.searchQuery}
                    placeholder={translate('agents.searchInputPlaceholder')}
                />
            </Box>

            {!role.isOneCompanyUser() ? (
                <OverviewCustomerCompanySelect
                    onChange={(customerIds) => {
                        navigate({
                            search: (previousSearch) => ({ ...previousSearch, customerIds, page: 0 }),
                        });
                    }}
                    value={search.customerIds}
                />
            ) : null}

            <Box minWidth="250px">
                <PortMultiSelect
                    placeholder={translate('agents.portsPlaceholder')}
                    value={search.portIds}
                    onChange={(portIds: string[]) => {
                        navigate({
                            search: (previousSearch) => ({ ...previousSearch, portIds, page: 0 }),
                        });
                    }}
                    dropdownWidth="520px"
                />
            </Box>
        </Box>
    );
};
